import React from 'react';
import CreateUser from '../components/CreateUser';
import PageLayout from '../components/layout/PageLayout';

const UserCreatePage = () => (
  <PageLayout>
    <CreateUser />
  </PageLayout>
);

export default UserCreatePage;